import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import PageModIntro from "../PageModIntro/PageModIntro";

const ServiceBannerContent = (props) => {
  const { serviceBannerContentProps } = props;
  return (
    <section className="py-3">
      <div className="container py-3">
        <div className="row text-md-left">
          <div className="col-md-6 text-grey">
            <p className="font-w500 font-20">
              {serviceBannerContentProps.tagLine?.map((tl, i) => (
                <Fragment key={i}>
                  {tl}
                  <br />
                </Fragment>
              ))}
            </p>
            <hr className="line-bot-green-74" />
            <h3 className="font-40 font-w800 text-dark text-dark mb-2">
              {serviceBannerContentProps.bannerTitle}
            </h3>
            <div className="page-mod-intro-text">
              {serviceBannerContentProps.bannerDesc?.map((bd, i) => (
                <p key={i}>{bd}</p>
              ))}
            </div>
            <div className="btn-group justify-content-space">
              {serviceBannerContentProps.QuickAcationBtn && (
                <Link className="primary-btn text-uppercase" to="/contact-us">
                  {serviceBannerContentProps.QuickAcationBtn}
                </Link>
              )}
            </div>
          </div>
          <div className="col-md-1"></div>
          <div className="col-md-5">
            <img
              draggable="false"
              src={serviceBannerContentProps.bannerImg}
              className="img-fluid"
              alt="offer"
            />
          </div>
        </div>
        {serviceBannerContentProps.pageModIntro && (
          <PageModIntro pageModIntro={serviceBannerContentProps.pageModIntro} />
        )}
      </div>
    </section>
  );
};

export default ServiceBannerContent;
